import React, { useContext } from 'react';
import { FormStateContext, FormStateProvider } from "../FormStateProvider";
import { ProgressBarProvider, useAppContext } from "../CEF/Providers";
import { Snackbar } from "../SnackBar";
import { OnboardingFormController } from "../controller/OnboardingFormController";
import { Route, Switch } from 'react-router-dom';
import { Routes as RoutePaths } from "../CEF/Common/Constants";
import DesktopDialog from "../CEF/Layout/DesktopDialog";
import { BudgetPage, CountriesPage, FieldsOfEducationPage, IntakesPage, ProgramLevelFamiliesPage } from "./Pages";
import MobileDialog from "../CEF/Layout/Wrappers/MobileDialog";
import { EnglishTestsQuestion, GraduateTestsQuestion, HighestEducationQuestion, NationalityQuestion, OverallGradeQuestion, ProvinceOfResidence } from "../CEF/Pages";
import { AdvisorConfirmationPage, PathwayPage } from "../ApplyBoost/Pages";
export function OnboardingRoutes(props) {
  var _useAppContext = useAppContext(),
    userId = _useAppContext.userId;
  return /*#__PURE__*/React.createElement(OnboardingFormController, {
    onExit: props.onExit
  }, /*#__PURE__*/React.createElement(FormStateProvider, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: RoutePaths.Preferences.CountriesPage
  }, /*#__PURE__*/React.createElement(DesktopDialog, null, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 0
  }, /*#__PURE__*/React.createElement(CountriesPage, null)))), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: RoutePaths.Preferences.EducationLevelFamiliesPage
  }, /*#__PURE__*/React.createElement(DesktopDialog, null, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: userId ? 10 : 25
  }, /*#__PURE__*/React.createElement(ProgramLevelFamiliesPage, null)))), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: RoutePaths.Preferences.FieldsOfEducationPage
  }, /*#__PURE__*/React.createElement(DesktopDialog, null, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: userId ? 20 : 50
  }, /*#__PURE__*/React.createElement(FieldsOfEducationPage, null)))), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: RoutePaths.Preferences.BudgetPage
  }, /*#__PURE__*/React.createElement(DesktopDialog, null, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: userId ? 30 : 75
  }, /*#__PURE__*/React.createElement(BudgetPage, null)))), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: RoutePaths.Preferences.IntakesPage
  }, /*#__PURE__*/React.createElement(DesktopDialog, null, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: userId ? 40 : 100
  }, /*#__PURE__*/React.createElement(IntakesPage, null)))), userId && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Eligibility.NationalityQuestion
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 50
  }, /*#__PURE__*/React.createElement(NationalityQuestion, {
    onExit: props.onExit,
    onSave: props.onSave
  })))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Eligibility.ProvinceOfResidenceQuestion
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 63
  }, /*#__PURE__*/React.createElement(ProvinceOfResidence, {
    onExit: props.onExit,
    onSave: props.onSave
  })))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Eligibility.HighestEducationQuestion
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 76
  }, /*#__PURE__*/React.createElement(HighestEducationQuestion, {
    onExit: props.onExit,
    onSave: props.onSave
  })))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Eligibility.OverallGradeQuestion
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 84
  }, /*#__PURE__*/React.createElement(OverallGradeQuestion, {
    onExit: props.onExit,
    onSave: props.onSave
  })))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Eligibility.EnglishTestsQuestion
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 92
  }, /*#__PURE__*/React.createElement(EnglishTestsQuestion, {
    onExit: props.onExit,
    onSave: props.onSave
  })))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Eligibility.GraduateTestsQuestion
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 96
  }, /*#__PURE__*/React.createElement(GraduateTestsQuestion, {
    onExit: props.onExit,
    onSave: props.onSave
  })))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.ApplyBoost.PathwayPage
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 100
  }, /*#__PURE__*/React.createElement(PathwayPage, null)))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.ApplyBoost.AdvisorConfirmationPage
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(AdvisorConfirmationPage, null))))), /*#__PURE__*/React.createElement(FormStateConsumerSnackbar, null)));
}
var FormStateConsumerSnackbar = function FormStateConsumerSnackbar() {
  var context = useContext(FormStateContext);
  if (!context) {
    throw new Error('FormStateConsumerSnackbar must be wrapped in a FormStateProvider');
  }
  var openSnackbar = context.openSnackbar,
    message = context.message;
  return /*#__PURE__*/React.createElement(Snackbar, {
    openSnackbar: openSnackbar,
    message: message
  });
};